module.exports = __webpack_public_path__ + "img/penta_5_express.86a45921.png";